import ListLayout from "../../components/layout/main/ListLayout";
import { CFlex } from "../../styles/CommonStyles";


const Dashboard = () => {


    return (
        <ListLayout>
            <CFlex fw>
                <>text</>
            </CFlex>
        </ListLayout>
    )
}

export default Dashboard
